import { AppState } from '../reducers';

export const dialogStateSelector = (state: AppState) => state.dialogState;

export const isDialogOpenSelector = (state: AppState, dialogId: string): boolean => {
  const dialogState = dialogStateSelector(state);
  return !!dialogState.dialogId && dialogState.dialogId === dialogId ? dialogState.isOpen : false;
};
